export const NomeFiltro =
{
    Regional: 'Regional',
    Cidade: 'Cidade',
    Empreendimento: 'Empreendimento',
    Geral: 'Geral'
}

export const CacheFiltro = 
{
    Regionais: 'cacheFiltroRegionais',
    Cidades: 'cacheFiltroCidades',
    Empreendimentos: 'cacheFiltroEmpreendimentos'
}

export const PermissoesUsuario = 
{
    LogarSistema: "af6b34f3-7311-4e63-8fd5-7effd55ec8b6",
    ConsultarParametrosRating: "6723ed1c-73ee-4b30-8953-1ff2bb0ff7b2",
    ConsultarParametrosBancario: "47294d6e-a5ed-4d02-82b7-089b5b644af9",
    ConsultarParametrosSimululacaoCredito: "72b82464-0216-4682-a117-6ec4a94cf149",
    ConsultarParametrosProposta: "7df6dcc0-b759-43bd-bfea-c2f8fcd1c66f",
    ConsultarParametrosPDDGerador: "a3c62a3f-25c7-4696-9c9a-234f6f5fc126",
    ConsultarParametrosSeguro: "f2e037eb-5fc9-416c-814c-0db844f1f6be",
    ConsultarParametrosPDDIntermediaria: "ab2e3f29-8ea2-4f95-a917-28876e6dcdbc",
    ConsultarParametrosCotaFinanciamento: "ccbe9233-aaf8-4dd7-839b-adf464fff9b0",
    ConsultarParametrosProjecaoMensal: "0d18344b-c536-401f-815a-666f0df37a05",
    ConsultarParametrosJurosFinanciamento: "b0405f61-6ca0-4405-921b-30ff2145bc8f",

    EditarParametrosRating: "2a6bc8f7-f4be-4752-91b0-94611fad92e2",
    EditarParametrosBancario: "1f2efae0-96c4-4ad3-91b2-5e1a242255a1",
    EditarParametrosSimululacaoCredito: "7d1b7ca2-fe7a-4c12-ae83-5fe5dcf60856",
    EditarParametrosProposta: "fc14f210-eb68-4928-ab00-f08e898b5a69",
    EditarParametrosPDDGerador: "ac143864-8243-4ed9-8da4-4cc9bc713802",
    EditarParametrosSeguro: "3c1dfc73-1df9-43a9-8480-a164f19ca6b4",
    EditarParametrosPDDIntermediaria: "35fabe12-360f-4f75-b0ec-0cd90b0a37d6",
    EditarParametrosCotaFinanciamento: "0907b68f-7c1b-492f-91b3-970167456032",
    EditarParametrosProjecaoMensal: "a69bc6dd-c9e9-4a3e-b3d4-3b68397d635c",
    EditarParametrosJurosFinanciamento: "e23fa9ff-ac90-417a-a637-31f735bf5de7",
    EditarDescontoFlex: "299783F7-5FE7-456F-8DCD-CBA76726176C",
    EditarParametroCupom: "aea6ac76-80bf-4cc0-aa3f-142b9821e9e3",
    EditarParametroFatorMargemVplAlvo: "a1d75dee-8b35-476e-9fc4-68821c8b5c19",
    EditarParametroFlex: "f98782fd-8410-4739-8384-dfd5c3e83f2b",
    EditarParametroProSolutoB: "7A6A66B6-964F-4D47-9395-64FAB2DF6E8C",
    EditarParametroCluster: "ad99a53f-782c-4e35-be86-caeb4d29fbea",
    EditarParametrosRatingCluster: "8f764b7d-aa58-442b-a19f-c01714f688fc",
    EditarComissao: "5BAF4CC7-47A4-453B-962A-4870993B23C7",
    EditarComissaoFlex: "A3E8F9D2-5C7B-4A1E-9F3D-8B6C4E2A7D5F",
    EditarDiferencaComissao: "6B48198C-09F9-4FBC-B1EA-8520D7EBAFD0",
    EditarLimiteComissao: "339D666E-C86F-46BA-9C75-A50A6407127A",
    EditarParcelamentoComissao: "5C0CC8A7-3034-4397-A018-7827DB2F39B4",
    EditarEmpreendimentosExcluidos: "7C127124-E525-4B5D-BF01-55CC7DB12A69",
    EditarProjecaoMensalFlex: "6F675B31-E4F1-4CDA-9E72-088621D41B54",
    EditarRegrasExtrasFlex: "7a6925f1-3ee8-4e38-94c0-f3c564475e59",

    DeletarParametrosRating: "236a5171-3973-4228-a967-6732da207a8d",
    DeletarParametrosBancario: "85ac9a4f-0cb0-464d-bfda-c5a512d07b60",
    DeletarParametrosSimululacaoCredito: "e6702bf9-7459-44de-84ce-90ac106604bf",
    DeletarParametrosProposta: "6d6aaa7a-2246-4177-a004-c79a25e1f764",
    DeletarParametrosPDDGerador: "16b82054-9f36-4854-bfc3-b43eb7eedd99",
    DeletarParametrosSeguro: "37e17679-af3d-4b81-8e3d-b703b58bf198",
    DeletarParametrosPDDIntermediaria: "7b18cabc-4e7f-4fcd-8d68-e6f0ed733c15",
    DeletarParametrosCotaFinanciamento: "457e5b26-11bf-4e8f-b3d5-10d744156728",
    DeletarParametrosProjecaoMensal: "ff77d41c-53e4-41b8-922d-cd75fd9a705e",
    DeletarParametrosJurosFinanciamento: "854f5e3a-4015-4a68-a86d-5ddc25520329",

    ImportarParametrosRating: "e0f945f9-df09-4dba-a40b-1835a648470d",
    ImportarParametrosBancario: "3e7391c0-49f4-4081-b221-a7dfbf80ae58",
    ImportarParametrosSimululacaoCredito: "71702fa2-09cc-4d61-ba2c-7d0330a810e4",
    ImportarParametrosProposta: "45f367b9-ff92-4553-bd8b-bc6a1d635cf4",
    ImportarParametrosPDDGerador: "fc352526-feb5-4c70-b8ab-9c90823957e2",
    ImportarParametrosSeguro: "075bb7a8-0b3c-410b-816c-9fc8dcce5254",
    ImportarParametrosPDDIntermediaria: "ae0a214e-f46b-4b69-9aaf-fb69acc98147",
    ImportarParametrosCotaFinanciamento: "db6e2899-a957-4558-aa24-d5fd9f9d891b",
    ImportarParametrosProjecaoMensal: "b693ee66-cca4-453f-bd02-aee392d27fe6",
    ImportarParametrosJurosFinanciamento: "32273709-6305-4035-96e8-0f620a5e257e",

    ExportarParametrosRating: "a4fc9251-ac71-41ac-b1c4-0f7a420ff708",
    ExportarParametrosBancario: "f5d21747-7606-4c57-b94c-017c5bf78512", 
    ExportarParametrosSimululacaoCredito: "f9de3c5f-c551-48ce-a09c-709e9dd7698f",
    ExportarParametrosProposta: "cd2536e9-a93a-47a2-a784-7726c07b07d5",
    ExportarParametrosPDDGerador: "e249401d-40cd-4214-a396-71c88ba11e7a",
    ExportarParametrosSeguro: "90a8f860-db08-4bcf-bb47-3ad530e182aa",
    ExportarParametrosPDDIntermediaria: "3801fc15-b3e1-441f-8a54-c9543b7d3bb2",
    ExportarParametrosCotaFinanciamento: "c0050b58-27eb-4715-b6b2-dcd9cd86632f",
    ExportarParametrosProjecaoMensal: "7a5bcc4a-17ee-4b89-84f7-abc2f092215e",
    ExportarParametrosJurosFinanciamento: "20b21c4f-49ab-49da-924f-9e34bac579f1",

    AplicarParametrosRating: "b2eb14bb-e61a-4463-9267-1fe7807f0c48",
    AplicarParametrosBancario: "4fb97f11-64ac-4524-bed8-ad91bc1d792d",
    AplicarParametrosSimululacaoCredito: "2c47c4b8-a74e-43bd-8e0d-7eb9e41026ae",
    AplicarParametrosProposta: "8318ba58-7e0f-42c2-b039-4c07f17c1e83",
    AplicarParametrosPDDGerador: "2df76e54-adb1-4e74-aec5-d0ba0e42fb7b",
    AplicarParametrosSeguro: "31f1a925-a6c6-4d3d-955b-c6718c84aa48",
    AplicarParametrosPDDIntermediaria: "1d46d931-00d1-4f3b-99c2-5a2d54a090ab",
    AplicarParametrosCotaFinanciamento: "208fd5a4-b4ad-403a-b950-cbd8c418120f",
    AplicarParametrosProjecaoMensal: "07e9eba3-a436-413d-bd09-d247a248798d",
    AplicarParametrosJurosFinanciamento: "9111b00c-fe8a-4f11-9c94-bcbe4e8365e5",

    VisualizarLogs: "64ae8376-572c-404c-9b08-d8213ab25f0a",
    ExportarAnaliseProposta: "5B4A3928-1706-F5E4-D3C2-B1A09F8E7D6C",
    ExportarRegistroAnaliseProposta: "9e144be2-56e8-426c-aa25-6a74750f58be",
    ExportarLimiteSimulacao: "e4d1eb9d-8836-4893-84ea-1d524388033c",
    ExportarLimiteNegociacao: "8E4A3928-1706-F5E4-D3C2-B1A09F8E7D6C",
    ExportarTabelao: "9F4A3928-1706-F5E4-D3C2-B1A09F8E7D6C",
    ExportarAnalisePropostaInvalida: "1EC488E8-9422-4489-988E-AD2E8D87239C",
}

export const TabelaHerdada = 
{
    Regional: "REGIONAL",
    Cidade: "CIDADE",
    Empreendimento: "EMPREENDIMENTO",
    Geral: "GERAL"
}